// No idea why this is in the "Progress" folder
export { default } from '@material-ui/core/CircularProgress';
//# sourceMappingURL=index.js.map